// 英文
const en = {
    header: {
        // 顶部导航栏
        titleList: [
            { title: '主頁' },
            { title: '關於我們' },
            { title: 'AIR' },
            // { title: 'GREEN' },
            { title: 'CARE' },
            { title: '2D體驗館' },
            { title: '預約空氣檢测' },
            { title: '企業資訊' },
            { title: '加入我們' },
            { title: '訂閱我們' }
        ]
    }
}
export default en


// WEBPACK FOOTER //
// ./src/lang/en.js